
module.exports = {
    url: 'https://www.deliciousexperiences.com/blog',
    pathPrefix: '/blog/',
    googleAnalyticsId: 'UA-164011094-2', 
    title: 'Delicious Experiences Blog',
  };